
import { Options } from "vue-class-component";

import { Col, Row, List } from "vant";
import AppUtil from "@/util/AppUtil";
import BaseList from "@/common/BaseList";

@Options({
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [List.name]: List,



  },
})
/**我的股本 */
export default class Capital extends BaseList {
  data = {
    ableMoney: 0,

    allMoney: 0,
    id: 0,
    checkMoney: 0,
  };
  reqUrl = "/zhShareholder/shareholder/getCapitalNotesList";


  //   finished=true;
  _title = "我的股本";

  mounted(): void {

    this.req_info();
  }

  req_info() {
    AppUtil.request(
      { url: "/zhShareholder/shareholder/getCapitalInfo", method: "post" },
      this.get_money
    );
  }
  /**获取佣金信息 */
  get_money(res: any) {
    console.log("我的股本", res);
    this.data = res.data;
    // this.reqData.cardId=res.data.id;
    // this.req_items()
  }




}
